import { DataCrafterTemplateImportDropdownValue, DataCrafterTemplateImportMapping } from '..';

export default class DataCrafterTemplateImportResponse {
    exportedTemplateFileName: string;
    mapperTableData: DataCrafterTemplateImportMapping[];
    modelMapperTableData?: DataCrafterTemplateImportMapping[];
    packageSelectionOptions: DataCrafterTemplateImportDropdownValue[];
    modelSelectionOptions: DataCrafterTemplateImportDropdownValue[];
}
